import React from 'react';
import { graphql } from 'gatsby';
import cx from 'classnames';
import { Container, Row, Col } from 'reactstrap';

import Layout from '../components/Layout';
import { HTMLContent } from '../components/Content';
import Content from '../components/Content';
import Section from '../components/Section';
import Hero from '../components/Hero';

export const GeneralPageTemplate = ({
  contentComponent,
  sections,
  hero,
  html,
  html_header,
  html_width,
  ...other
}) => {
  const PageContent = contentComponent || Content; // needed to cooperate with Netlify CMS preview

  if (process.env.NODE_ENV === 'development') {
    console.log('got hero =', hero);
    console.log('got sections =', sections);
    console.log('got html =', html);
    console.log('got html_width =', html_width);
    console.log('got html_header =', html_header);
    console.log('other props =', other);
  }

  // the CMS sometimes leaves us with a hero header "" when a hero has been removed.
  if (hero && !hero.header && !hero.description && !hero.image) {
    hero = null;
    if (process.env.NODE_ENV === 'development') {
      console.log('setting hero to null since it is empty.');
    }
  }

  return (
    <div>
      {hero && <Hero contentComponent={PageContent} hero={hero} />}
      {sections &&
        sections.map((section, i) => (
          <Section
            key={i}
            section={section}
            className={cx({
              'top-section': i === 0 && hero == null,
              'pt-0 mt-4':
                (hero != null && i === 0 && section.bg == null) || // no hero first item and not purple bg
                (sections[i - 1] && section.bg === sections[i - 1].bg), // same color as previous section, limit padding
            })}
            contentComponent={PageContent}
          />
        ))}
      {html && (
        <Container>
          <Row>
            <Col>
              <div
                className={cx('section', {
                  'top-section': hero == null,
                  'text-container mx-auto': html_width !== 'full',
                })}
              >
                {html_header && (
                  <h1 className="text-primary text-uppercase mb-4">
                    {html_header}
                  </h1>
                )}
                <PageContent className="page-content" content={html} />
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default class GeneralPage extends React.Component {
  render() {
    const { data } = this.props;
    const { markdownRemark } = data;
    const { frontmatter, html } = markdownRemark;
    let path = frontmatter.path || markdown.fields.slug;

    // pathnames in CMS sometimes have leading /, othertimes do not
    if (path[0] !== '/') {
      path = `/${path}`;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('data = ', data);
    }

    return (
      <Layout title={frontmatter.title} path={path}>
        <GeneralPageTemplate
          contentComponent={HTMLContent}
          html={html}
          {...frontmatter}
        />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }

    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        html_header
        html_width
        path
        hero {
          header
          type
          meta
          col_sizes
          description
          call_to_action
          call_to_action_url
          image {
            childImageSharp {
              fluid(maxWidth: 1270, quality: 90) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        sections {
          header
          pre_header
          description
          type
          bg
          id
          centered_text
          call_to_action
          call_to_action_url
          meta
          items {
            header
            description
            call_to_action
            call_to_action_url
          }
          image_caption
          image {
            childImageSharp {
              fluid(maxWidth: 1270, quality: 90) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
